module.exports = __webpack_public_path__ + "static/media/landing-popup.3f25f5e3.svg";